<template>
  <div class="text-center fiska-frame">
    <p>Please wait while we are processing...</p>
  </div>
</template>
<script>

import { mapMutations } from "vuex";

export default {
  name: 'FiskaResponse',
  data() {
    return {
   
    };
  },

  async mounted() {
    this.vm_mutateFiskaDetails({
      fiska_response: this.$router.currentRoute.query, //this.$route.query
    })
  },

  methods: {

    ...mapMutations({
      vm_mutateFiskaDetails: "fiska/detailsMutate",
    }),

  },
};
</script>

<style scoped>
.fiska-frame{
    min-height: 500px;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>